module.exports = __webpack_public_path__ + "img/step5.719c89d0.jpg";